@for (conta of contas; track conta.idContasReceber) {
    <div class="pvfl-item">
        <div class="pvfl-item-cabecalho">
            <mat-icon class="material-symbols-outlined pvfl-item-icone">receipt_long</mat-icon>
            <span class="pvfl-item-titulo">Título {{ conta.numeroDocumento ? '#' + conta.numeroDocumento : '' }} — {{ conta.descricaoOriginal }}</span>
            <span class="pvfl-item-valor">{{ conta.valorTotal | abnt:'preco':2 }}</span>
            @if (!isExclusao && podeVerContasReceber) {
                <a class="pvfl-link" [href]="linkTitulo(conta)" target="_blank" rel="noopener"
                    matTooltip="Abrir o título no contas a receber (nova aba)." aria-label="Abrir o título no contas a receber">
                    <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
                </a>
            }
        </div>
        <div class="pvfl-linhas">
            @for (parcela of conta.parcelas; track parcela.idContasReceberParcela) {
                <div class="pvfl-linha" [class.pvfl-bloqueada]="isExclusao && !!parcela.motivoBloqueioExclusao"
                    [class.pvfl-cancelada]="isCancelada(parcela)">
                    <span>{{ parcela.nroParcela }}/{{ conta.parcelas.length }}</span>
                    <span>{{ parcela.datetimeVencimento | date:'dd/MM/yyyy' }}</span>
                    <span class="pvfl-valor">{{ parcela.valor | abnt:'preco':2 }}</span>
                    <span class="pvfl-situacao">{{ isExclusao ? acaoParcela(parcela) : situacaoParcela(parcela) }}</span>
                    @if (previstos(parcela); as partes) {
                        @if (partes.length) {
                            <span class="pvfl-previstos">
                                @for (p of partes; track p.rotulo) {
                                    @if (!$first) { · }{{ p.rotulo }} {{ p.valor | abnt:'preco':2 }}
                                }
                            </span>
                        }
                    }
                </div>
            }
        </div>
    </div>
}

@for (mov of movimentacoes; track mov.idMovimentacao) {
    <div class="pvfl-item" [class.pvfl-bloqueada]="isExclusao && !!mov.motivoBloqueioExclusao">
        <div class="pvfl-item-cabecalho">
            <mat-icon class="material-symbols-outlined pvfl-item-icone">{{ isTarifa(mov) ? 'payments' : 'account_balance_wallet' }}</mat-icon>
            <span class="pvfl-item-titulo">{{ isTarifa(mov) ? 'Tarifa do intermediador' : 'Movimentação' }} em {{ mov.descricaoConta }} ({{ mov.dataMovimentacao | date:'dd/MM/yyyy' }})</span>
            <span class="pvfl-item-valor">{{ mov.valor | abnt:'preco':2 }}</span>
            @if (!isExclusao && podeVerExtrato) {
                <a class="pvfl-link" [href]="linkMovimentacao(mov)" target="_blank" rel="noopener"
                    matTooltip="Abrir a movimentação no extrato (nova aba)." aria-label="Abrir a movimentação no extrato">
                    <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
                </a>
            }
        </div>
        <div class="pvfl-situacao pvfl-situacao-mov">{{ isExclusao ? acaoMovimentacao(mov) : situacaoMovimentacao(mov) }}</div>
    </div>
}
